import { createContext, useContext } from "react";
import { airlines as defaultAirlines } from "../data/airlines";

const AirlineContext = createContext();

/**
 * AirlineProvider — receives a full airline config (from route/backend) and exposes it.
 * There is no in-context "switching" anymore: airline identity is determined by
 * the URL route + backend authorization, not by client-side localStorage.
 */
export const AirlineProvider = ({ airline, children }) => {
  const resolved = airline || defaultAirlines.default;
  const value = {
    airline: resolved,
    airlineId: resolved.id,
  };
  return <AirlineContext.Provider value={value}>{children}</AirlineContext.Provider>;
};

export const useAirline = () => useContext(AirlineContext);
